import ReactPaginate from 'react-paginate';
import { QueryTypense } from "./Searchbar";

const itemsPerPage = 10;


export default function Pagination({resultsNumber, setPageNumber, searchValue, filtersDict, onQuery}){

    console.log("From Pagination.jsx:")
    console.log("resultsNumber: ", resultsNumber)

    if (resultsNumber == undefined){
        return null;
    }

    const pageCount = Math.ceil(resultsNumber / itemsPerPage);

    // Invoke when user click to request another page.
    const handlePageClick = (event) => {
        
        const pageNumber = event.selected + 1;

        console.log(
            `User requested page number ${pageNumber}`
            );

        // Set the new page number
        setPageNumber(pageNumber);

        // Scroll to the top of the page
        // window.scrollTo(0, 0);

        // Scroll with animation to the top of the page
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });

        // Make query to Typensense
        QueryTypense(searchValue, filtersDict, onQuery, pageNumber);


        
    };

    return(
        <ReactPaginate
            breakLabel="..."
            nextLabel="siguiente >"
            onPageChange={handlePageClick}
            pageRangeDisplayed={5}
            pageCount={pageCount}
            previousLabel="< anterior"
            renderOnZeroPageCount={null}
            containerClassName="pagination"
            pageLinkClassName="page-num"
            previousLinkClassName="page-num"
            nextLinkClassName="page-num"
            activeClassName="active"
        />
    )



}